import Login from "./app/ui-web/stateless/login";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Route } from "react-router-dom";
import { Routes } from "react-router-dom"
import Navbar from "./app/ui-web/shared/Navbar/Navbar";
import ErrorBoundary from "./app/ui-web/error-pages/ErrorBoundary";
import { apiHostUrl } from "./constants/constants";
import SsoPostLogin from "./app/ui-web/stateless/SPostLogin";
import SurveyForm from './app/ui-web/pages/survey/SurveyForm'
import Survey from "./app/ui-web/stateless/Survey";
import LoginForm from "./app/ui-web/stateless/loginForm";
import SideBar from "./app/ui-web/shared/SideBar";
import { useRefreshState } from "./app/hooks/useRefreshState";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import LoadingPage from "./app/ui-web/stateless/LoadingPage";
import { applicationContextRoot } from "./constants/constants";
import AddProspectiveCustomerFeedback from "./app/ui-web/pages/prospective/AddProspectiveCustomerFeedback";

library.add(fas);

function App() {

  let existingCSPMetas = document.querySelectorAll('meta[http-equiv="Content-Security-Policy"]');
  if (existingCSPMetas && existingCSPMetas.length > 0) {
    document.getElementsByTagName('head')[0].removeChild(existingCSPMetas[0]);
  }

  const url = new URL(apiHostUrl);
  if (url.protocol == "https:") {
    var meta = document.createElement('meta');
    meta.httpEquiv = "Content-Security-Policy";
    meta.content = "upgrade-insecure-requests";
    document.getElementsByTagName('head')[0].appendChild(meta);
  }


  const roles = useSelector((state) => state.role);
  const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  
  useEffect(() => {
    console.log("roles", roles)
  }, [roles.userCurrRole, roles])
  return (
    <Routes>
      {/* <Route exact path={applicationContextRoot+"/post-login/:param1/:param2/:param3"} element={

        <SsoPostLogin />

      }>
      </Route> */}
      <Route path={applicationContextRoot+"/login"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <Login />
        </ErrorBoundary>
      }>
        </Route>
        <Route path={applicationContextRoot} element={
          <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
            <LoadingPage />
          </ErrorBoundary>
        }></Route>

      <Route path={applicationContextRoot+"/home"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <SideBar />
          {/* <Navbar/> */}
        </ErrorBoundary>
      }>
      </Route>
      <Route path={applicationContextRoot+"/survey/launch-survey/:param1"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <Login />
        </ErrorBoundary>
      }>
      </Route>
      <Route path={applicationContextRoot+"/survey/get-survey/:departmentId/:srvcUserId"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <LoginForm encoded={false} />
        </ErrorBoundary>
      }>
      </Route>
      <Route path={applicationContextRoot+"/survey/start-survey/:param1"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <LoginForm encoded={true} />
        </ErrorBoundary>
      }>
      </Route>
      <Route path={applicationContextRoot+"/survey/launch-survey/"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <SurveyForm />
        </ErrorBoundary>
      }></Route>
      <Route path={applicationContextRoot+"/prospective/customer/feedback/:departmentId"} element={
        <ErrorBoundary csrfFormTagName={csrfFormTagName} csrfToken={csrfToken}>
          <AddProspectiveCustomerFeedback />
        </ErrorBoundary>
      }></Route>
    </Routes>
  );
}

export default App;
